
import { Injectable } from '@angular/core';
import { AlertService } from './alert.service';
import { Observable } from 'rxjs/Observable';
import { forkJoin } from 'rxjs/observable/forkJoin';

@Injectable()
export class HttpOperationsService {
  constructor(private alertService: AlertService) { }

  public bulkProcessObservables(observables: Observable<any>[], operationName: string, successCallback?: () => void) {

    let errors = [];
    const successes = [];
    forkJoin(observables)
      .finally(
        () => {
          // filter out null elements
          errors = errors.filter(element => element !== null);
          if (errors.length === 0) {
            this.alertService.successModal(operationName + ' successful');
            if (successCallback && typeof successCallback === 'function') {
              successCallback();
            }
          } else {
            this.alertService.errors(errors, successes, operationName);
          }
        }
      )
      .subscribe(
        error => {
          errors = error;
          console.log('error:' + JSON.stringify(error));
        },
        result => {
          // Handle result
          console.log('result:' + JSON.stringify(result));
          if (result.status !== 200) {
            errors.push(result);
          } else {
            successes.push(result);
          }
        }

      );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/http-operations.service.ts